import firebase from 'firebase/app';

const COLLECTION_NAME = 'Preference';
const DOCUMENT_NAME = 'NPS';

export function createUserNPS(userId, courseCode, nps_state) {
  return firebase
    .firestore()
    .collection(COLLECTION_NAME)
    .doc(DOCUMENT_NAME)
    .collection('Users')
    .doc(userId)
    .set({
      created: firebase.firestore.FieldValue.serverTimestamp(),
      [courseCode]: nps_state,
    });
}

export function updateUserNPS(userId, courseCode, nps_state) {
  return firebase
    .firestore()
    .collection(COLLECTION_NAME)
    .doc(DOCUMENT_NAME)
    .collection('Users')
    .doc(userId)
    .update({ [courseCode]: nps_state });
}

export function getUserNPS(userId) {
  return firebase
    .firestore()
    .collection(COLLECTION_NAME)
    .doc(DOCUMENT_NAME)
    .collection('Users')
    .doc(userId)
    .get();
}

export function streamUserNPS(userId, observer) {
  return firebase
    .firestore()
    .collection(COLLECTION_NAME)
    .doc(DOCUMENT_NAME)
    .collection('Users')
    .doc(userId)
    .onSnapshot(observer);
}
